import { SkeletonBlock } from './SkeletonBlock';

export const KybStatusSkeleton = () => {
  return (
    <div className="w-60 h-16 rounded-xl p-2.5 flex flex-col justify-between gap-1.5 bg-[#151717]">
      <div className="flex items-center gap-2">
        <SkeletonBlock className="size-6 rounded-full" />
        <div className="flex-1">
          <SkeletonBlock className="h-4 w-[120px] rounded" />
        </div>
      </div>

      <div className="w-28">
        <SkeletonBlock className="h-[18px] w-[110px] rounded-lg" />
      </div>
    </div>
  );
};
